import type { ThemeColorModes } from '@atlaskit/tokens';

export const themeColorModes: ThemeColorModes[] = ['light', 'dark', 'auto'] as const;
export const DEFAULT_COLOR_MODE: ThemeColorModes = 'auto';
